
import { Options, Vue } from "vue-class-component";

type Item = {
  id?: string | number;
  caseTypeLabel?: string;
  caseNumber?: string;
  categoryName?: string;
  statusLabel?: string;
  info?: string;
};

@Options({
  props: {
    items: {
      type: Array as () => Item[],
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ["item-click"]
})
export default class GenericInfobar extends Vue {
  get infoText(): string {
    const items = (this.$props as any).items;
    const listCaseType = items
      .map((item: any) => this.mapCaseTypeLabel(item.caseTypeLabel))
      .join(", ");
    if ((this.$props as any).disabled) {
      return this.$t("pusatResolusi.infobar.reportLimit");
    }
    if (items.length) {
      return `${this.$t(
        "pusatResolusi.infobar.issue"
      )} <b>${listCaseType}</b> ${this.$t(
        "pusatResolusi.infobar.prohibitedReport"
      )}`;
    }
    return this.$t("pusatResolusi.infobar.reportLimit");
  }

  handleItemClick(item: Item) {
    this.$emit("item-click", item.id || 0);
  }

  mapBackgroundStyle(item: Item) {
    const caseType: any = {
      operation: "bg-red-lp-750",
      "non operation": "bg-blue-lp-800"
    };
    const caseTypeLabel = item.caseTypeLabel || "";

    return caseType[caseTypeLabel?.toLowerCase()] ?? "bg-blue-lp-800";
  }

  mapCaseTypeLabel(caseTypeLabel: string) {
    const caseType: any = {
      "non operation": "Non operation"
    };

    return caseType[caseTypeLabel?.toLowerCase()] ?? caseTypeLabel;
  }
}
